angular.module('clients')
    .component('clientSelect', {
        bindings: {
            onChange: '&?',
            modelType: '<?',
            required: "=?",
            disabled: "<?",
            customList: "=?",
            showPreview: "<?"
        },
        require: {
            ngModelCtrl: 'ngModel'
        },
        templateUrl: "app/clients/client-select/client-select.html",
        controller: function (Client, ClientService) {
            const ctrl = this;

            ctrl.$onInit = () => {
                ctrl.items = ctrl.customList || [];

                ctrl.ngModelCtrl.$render = () => ctrl.selected = ctrl.ngModelCtrl.$viewValue;
                ctrl.ngModelCtrl.$formatters.push(modelValue => modelValue);
                ctrl.ngModelCtrl.$parsers.push(viewValue => ctrl.modelType === "id" ? viewValue.id : viewValue);
            };

            ctrl.refreshList = q => Client.autocomplete({q: q}).$promise.then(items => ctrl.items = items);

            ctrl.addClient = () => ClientService.addModal().then(result => refresh(result));
            ctrl.editClient = id => ClientService.edit(id).then(result => refresh(result));

            ctrl.onSelectionChanged = ($item, $model) => {
                ctrl.ngModelCtrl.$setViewValue($item);
                ctrl.ngModelCtrl.$validate();
                ctrl.ngModelCtrl.$render();
                if (angular.isFunction(ctrl.onChange)) {
                    ctrl.onChange({$client: $item});
                }
            };

            function refresh(result) {
                ctrl.refreshing = true;
                ctrl.refreshList().then(() => {
                    ctrl.refreshing = false;
                    ctrl.selected = {
                        id: result.id,
                        symbol: result.symbol,
                        fullName: result.fullName,
                        fullAddress: result.fullAddress,
                        nip: result.nip,
                        status: result.status,
                    };
                    ctrl.onSelectionChanged(ctrl.selected);
                });
            }
        }
    })
